import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { BASE_URL } from "../../config/axios";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { useLocation, useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
// import { BillingDetailsTable, BillTable, ConsultancyDetails, ContractorDetails, COSTable, EmployeeTable, EOTTable, LetterTracking, MilestoneTable, Progress } from "./SiteProjectManagementComponents";
// import { handleErrorToast, formatCurrencyIndian, formatRoundoffCrores, formatRoundoff3D } from "../custom";
import Tabledesign from "../../components/Designstage/Tabledesign";
import TableReviewfile from "../../components/ReviewFile/TableReviewfile";
import { CircularGrid, Documentation } from "../AllSvg";
// import usePermission from "../../config/permissions";
// import { UpdateProject } from "../Modals/UpdateProjectDetails";
// import { AddProjectClientDetails, ProjectClientDetailsTable, ProjectInvoicesDetailsTable, ProjectInvoicesPaymentsTable, ProjectSubmissionDocumentTable, ProjectTenderDocumentTable } from "./ProjectDetailsPageComponents"
import { UpdateProject, AddDepartmentDetails } from "../Modals/UpdateProjectDetails";
// import { formattedDateLong } from "../Date";
// import UpdateProjectDetails from "../Modals/UpdateProjectDetails"

import { AddActivity, AddTask, EditActivity, UpdateTask } from "../Project/AllProjectdetailsmodal";


const AllTaskdetails = (projectId, departmentData, weightage, getDepartmentList) => {



    // console.log("location.state")
    // console.log(location.state)
    // console.log("projectID")


    const [buffer, setBuffering] = useState(false);

    const [clientslist, setClientsList] = useState([]);
    const [clientExists, setClientExists] = useState(false);

    const [client, setClient] = useState(null);
    const [clientwiseID, setClientWise] = useState(null);
    const [taskdetails, SetTaskdetails] = useState([])
    const [toggleState, settoggleState] = useState(1);

    const [project, setProject] = useState([]);

    const location = useLocation();

    // console.log(location.state);
    const [projectID, setProjectId] = useState('');


    const [allEmployeeData, setAllEmployeeData] = useState([]);


    const getTaskDeatils = async (id) => {
        try {
            const res = await axios.get(
                `${BASE_URL}/detail-design/activitytype/${id}/`
            );
            SetTaskdetails(res.data);
        } catch (err) {
            alert(err.message);
        }
    };
    useEffect(() => {
        // console.log("useffect running", location?.state.projectId
        // )
        setProjectId(location?.state?.projectId)




    }, [location]);

    useEffect(() => {
        console.log("projectId", projectID)
        if (projectID) {
            getTaskDeatils(projectID)
        }
    }, [projectID])

    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanysdep/${sessionStorage.getItem(
                    "departmentid"
                )}/`
            );
            setAllEmployeeData(res.data);
        } catch (err) {
            alert(err.message);
        }
    };



    const dummyData = [
        {
            "pr_code": 42,
            "client_name": "RAM KUMAR CONTRACTOR PVT LTD",
            "subcompany_name": "RKC",
            "project_code": "D1058",
            "project_name": "DAAT KALI PKG -2",
            "project_description": "Development of Six- lane access- controlled highway from Design Chainage 8+130 (near Mohand) to 16+380 Daat Kali Tunnel of Ganeshapur-Dehradun section of NH-72A in the state of Uttar Pradesh & Uttarakhand under Bharatmala Pariyojana on EPC Mode (Package-2)",
            "location": "DEHRADUN",
            "concern_person": "SUKHVINDER SINGH",
            "concern_person_name": null,
            "length": "8.2500",
            "wo_date": null,
            "start_date": null,
            "due_date": null,
            "project_mode": "EPC",
            "woamount": null,
            "gst_amount": null,
            "confirm_by": null,
            "confirmation_mode": null,
            "project_status": "pending",
            "sub_Company": "f175ffcf-dded-4e43-953d-d7a9eb9a77dd",
            "client": "fd2599f9-6f01-4799-a78b-46a462d007a1"
        },
        {
            "pr_code": 35,
            "client_name": "HILLWAYS CONSTRUCTION PRIVATE LIMITED",
            "subcompany_name": "HILLWAYS CONSTRUCTION PRIVATE LIMITED",
            "project_code": "D1060",
            "project_name": "KANPUR RING ROAD PKG-3",
            "project_description": null,
            "location": null,
            "concern_person": "Radhey Shram Sharma",
            "concern_person_name": null,
            "length": null,
            "wo_date": null,
            "start_date": null,
            "due_date": null,
            "project_mode": null,
            "woamount": null,
            "gst_amount": null,
            "confirm_by": null,
            "confirmation_mode": null,
            "project_status": "pending",
            "sub_Company": "b72dfb79-a50d-403f-b6c2-efbbf0481e8d",
            "client": "324f2155-6668-4746-84ab-591e50e7c84a"
        }
    ]
    const [openRows, setOpenRows] = useState({});

    const handleToggle1 = (id) => {
        setOpenRows((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };
    const renderActivityRows = (activities, level = 0, isChild = false) => {
        // return activities.map((activity, index) => {
        //     const hasParent = activity.activity_parent !== null;
        //     const hasChildren = Array.isArray(activity.sub_activity) && activity.sub_activity.length > 0;
        //     const isParent = hasChildren;
        //     const isChildOnly = !isChild && !isParent;

        //     const calculateCompletionWeightage = (activity) => {
        //         if (!activity.sub_activity || activity.sub_activity.length === 0) {
        //             return activity.approval_status === "approved" ? parseFloat(activity.weightage) || 0 : 0;
        //         }

        //         let totalWeightage = 0;
        //         let totalPercentage = 0;

        //         activity.sub_activity.forEach((child) => {
        //             const childWeightage = calculateCompletionWeightage(child);
        //             totalWeightage += childWeightage;
        //             totalPercentage += parseFloat(child.weightage) || 0;
        //         });

        //         return totalPercentage > 0 ? (totalWeightage / totalPercentage) * parseFloat(activity.weightage) || 100 : 0;
        //     };

        //     let rowClass = "";
        //     if (hasParent && isParent) {
        //         rowClass = "parent-child";
        //     } else if (isParent) {
        //         rowClass = "parent";
        //     } else if (isChildOnly) {
        //         rowClass = "child";
        //     }

        //     const paddingLeft = `${level * 20 + (isChild ? 15 : 5)}px`;

        //     const arrowIcon = isParent && hasChildren ? (
        //         openRows[activity.id] ? (
        //             <svg
        //                 xmlns="http://www.w3.org/2000/svg"
        //                 width="20"
        //                 height="25"
        //                 fill="currentColor"
        //                 className="bi bi-caret-down-fill"
        //                 viewBox="0 0 16 16"
        //             >
        //                 <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
        //             </svg>
        //         ) : (
        //             <svg
        //                 xmlns="http://www.w3.org/2000/svg"
        //                 width="25"
        //                 height="25"
        //                 fill="currentColor"
        //                 viewBox="0 0 24 24"
        //                 id="right-arrow"
        //             >
        //                 <g>
        //                     <g>
        //                         <rect opacity="0" transform="rotate(180 12 12)" />
        //                         <path d="M10.46 18a2.23 2.23 0 0 1-.91-.2 1.76 1.76 0 0 1-1.05-1.59V7.79A1.76 1.76 0 0 1 9.55 6.2a2.1 2.1 0 0 1 2.21.26l5.1 4.21a1.7 1.7 0 0 1 0 2.66l-5.1 4.21a2.06 2.06 0 0 1-1.3.46z" />
        //                     </g>
        //                 </g>
        //             </svg>
        //         )
        //     ) : null;

        //     return (
        //         <React.Fragment key={activity.id || index}>
        //             {((isParent && !hasParent) || (!hasChildren && !hasParent)) && (
        //                 <tr className={`custom-table-head-td ${rowClass}`}>
        //                     <td className="table-body text-center border-top-bottom">{index + 1}</td>
        //                     <td
        //                         className="table-body text-center border-top-bottom"
        //                         onClick={() => handleToggle1(activity.id)}
        //                         style={{ cursor: "pointer" }}
        //                     >
        //                         {arrowIcon}
        //                         {activity.activity_name || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.vendor_name_name || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.activity_type || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {calculateCompletionWeightage(activity).toFixed(2)}%
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.approval_status || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.assigned_to?.join(", ") || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.created_at ? new Date(activity.created_at).toLocaleDateString() : ""}
        //                     </td>
        //                 </tr>
        //             )}

        //             {hasParent && (
        //                 <tr className={`custom-table-head-td ${rowClass}`}>
        //                     <td className="table-body text-center border-top-bottom">{index + 1}</td>
        //                     <td
        //                         className="table-body text-center border-top-bottom"
        //                         style={{ cursor: "pointer", paddingLeft }}
        //                         onClick={() => handleToggle(activity.id)}
        //                     >
        //                         {arrowIcon}
        //                         {activity.activity_name || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.vendor_name_name || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.activity_type || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {calculateCompletionWeightage(activity).toFixed(2)}%
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.approval_status || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.assigned_to?.join(", ") || ""}
        //                     </td>
        //                     <td className="table-body text-center border-top-bottom">
        //                         {activity.created_at ? new Date(activity.created_at).toLocaleDateString() : ""}
        //                     </td>
        //                 </tr>
        //             )}

        //             {hasChildren && openRows[activity.id] && renderActivityRows(activity.sub_activity, level + 1, true)}
        //         </React.Fragment>
        //     );
        // });
    };
    const [menuopen, setMenuopen] = useState(false);
    const [menuopenrecieve, setMenuopenrecieve] = useState(false);
    const [menuopenstart, setMenuopenstart] = useState(false);
    const [menuIndex, setMenuIndex] = useState(null);
    const toggleMenu = (index) => {
        setMenuopen(!menuopen);
        setMenuIndex(index)
    };

    const toggleMenurecieve = (index) => {
        setMenuopenrecieve(!menuopen);

    };

    const toggleMenustart = (index) => {
        setMenuopenstart(!menuopen);

    };
    const menuRef = useRef(null);
    const menuRefrecieve = useRef(null);
    const menuRefstart = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && menuIndex === null && !menuRef.current.contains(event.target)) {
                setMenuopen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRefrecieve.current && !menuRefrecieve.current.contains(event.target)) {
                setMenuopenrecieve(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRefstart.current && !menuRefstart.current.contains(event.target)) {
                setMenuopenstart(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const navigate = useNavigate();


    const [isToggled, setIsToggled] = useState(false);
    const [startTime, setStartTime] = useState(null);

    const handleToggle = () => {
        const newToggleState = !isToggled;
        setIsToggled(newToggleState);

        if (newToggleState) {

            const time = new Date().toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });
            setStartTime(time);
        } else {
            setStartTime(null);
        }
    };



    return (

        <>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Dashboardnavbar name={`Project Details`} url="Project Details" />

            <div className="content-tabs">
                <div className="info-box-div-bg">
                    <div className="flex-row">
                        <div className="personal-detail" style={{ width: "100%" }}>
                            <div className="jd-heading-outer heading-bg-color-white" style={{ marginBottom: "10px", marginTop: '10px' }}>
                                <div className="jd-heading-outer-flex" style={{ alignItems: 'center' }}>
                                    <div className="flex-display" style={{ width: '50%' }}>
                                        <h3 className="task-main-heading" style={{ width: '31%' }}>
                                            {taskdetails[0]?.activity_name}
                                        </h3>
                                        <div className="project-name-bar-container" style={{ width: '26%', marginTop: '10px' }}>

                                            <span className="project-name font-weight-600">Progress:</span>
                                            <div className="progress-wrapper">
                                                <div className="progress-per" style={{ width: "20%" }}></div>
                                            </div>
                                            <span className="percentage-label">20%</span>
                                        </div>
                                    </div>

                                    <div className="jd-heading-outer-flex" style={{ alignItems: 'center', gap: "16px" }}>
                                        <div className="start-time-toggle-container">
                                            <div className="start-time-toggle-wrapper">
                                                <span className="start-time-toggle-label">Start Task</span>
                                                <label className="start-time-toggle-switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={isToggled}
                                                        onChange={handleToggle}
                                                    />
                                                    <span className="start-time-slider"></span>
                                                </label>
                                            </div>

                                            <div className="start-time">
                                                {startTime ? startTime : 'hh:mm:ss'}
                                            </div>

                                        </div>

                                        <EditActivity
                                            projectID={projectId}
                                            department_name={departmentData?.id}
                                            i={taskdetails[0]}
                                            weightage={weightage}
                                            // id={project.pr_code}
                                            // modalData={project}
                                            // allEmployeeData={allEmployeeData}
                                            getDepartmentList={getDepartmentList}
                                        />
                                        <button title="Bulk Upload Projects" class="common-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload"><g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path></g></svg> {" "}Export</button>
                                        {/* <UpdateProject
                                            id={project.pr_code}
                                            modalData={project}
                                            allEmployeeData={allEmployeeData}
                                            getProjectDetails={getProjectDetails}
                                        /> */}
                                    </div>
                                </div>

                            </div>

                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light-blue"></div>
                            </div>

                            <div className="info-box-div">
                                <div className="jd-heading-outer-flex" style={{ alignItems: 'center' }}>

                                    <tr>
                                        <td className="jd-heading-main font-weight600  font-size-heading">
                                            Description :
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                            {/* {project.location ? project.location : "-"} */}
                                            {taskdetails?.activity_description}
                                        </th>
                                    </tr>

                                </div>

                                <div className="personal-detail" style={{ width: '100%' }}>
                                    <div className="flex-display-cmnTable">
                                        <table>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                    <span className="task-details-heading font-18">Task Details :</span>
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text font-18">

                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                    Activity Name:
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                                    {/* {project.location ? project.location : "-"} */}
                                                    {taskdetails?.activity_description}
                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                    Activity Type :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                                    {/* {project.length ? parseFloat(project.length).toFixed(2) : "-"} */}
                                                    {taskdetails?.activity_type}
                                                </th>
                                            </tr>

                                            {taskdetails ? (
                                                <tr>
                                                    <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                        Assigned date:
                                                    </td>
                                                    <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                                        {taskdetails.assign_date || "-"}
                                                    </th>
                                                </tr>
                                            ) : null}
                                            {taskdetails ? (
                                                <tr>
                                                    <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                        Assigned date:
                                                    </td>
                                                    <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                                        {taskdetails.deadline_date || "-"}
                                                    </th>
                                                </tr>
                                            ) : null}



                                        </table>
                                        <table>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                    <span className="task-details-heading font-18">Department Detail:</span>
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text font-18">

                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                    Vendor Name :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                                    {/* {project.location ? project.location : "-"} */}
                                                    {taskdetails?.vendor_name}
                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                    Approval Status :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                                    {/* {project.length ? parseFloat(project.length).toFixed(2) : "-"} */}
                                                    {taskdetails?.approval_status}
                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                    Assigned Draftman :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                                    {/* {project.woamount ? parseFloat(project.woamount).toLocaleString() : "-"} */}
                                                    {taskdetails?.assigned_to}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text font-18">
                                                    Assigned TL :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text font-18">
                                                    {/* {project.without_gst_amount ? parseFloat(project.without_gst_amount).toLocaleString() : "-"} */}
                                                    {taskdetails?.assigned_by}
                                                </th>
                                            </tr>



                                        </table>
                                    </div>
                                    <div>
                                        <table>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    <span className="task-details-heading font-18">Documents:</span>
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">

                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text document-task-details">
                                                    <div className="documents-box-task-details">
                                                        <span><svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M21.9764 16.1875L8.14014 13.75V31.7612C8.13997 31.957 8.17845 32.1509 8.25336 32.3317C8.32828 32.5126 8.43816 32.6769 8.5767 32.8152C8.71524 32.9535 8.87972 33.0631 9.0607 33.1377C9.24169 33.2123 9.43563 33.2505 9.63139 33.25H33.5064C33.7024 33.2508 33.8966 33.2129 34.0778 33.1385C34.2591 33.064 34.4239 32.9544 34.5627 32.8161C34.7015 32.6778 34.8116 32.5133 34.8867 32.3323C34.9617 32.1513 35.0003 31.9572 35.0001 31.7612V25.125L21.9764 16.1875Z" fill="#185C37" />
                                                            <path d="M21.9764 0.750005H9.63139C9.43563 0.749511 9.24169 0.787664 9.0607 0.862275C8.87972 0.936886 8.71524 1.04649 8.5767 1.1848C8.43816 1.32311 8.32828 1.4874 8.25336 1.66826C8.17845 1.84912 8.13997 2.04299 8.14014 2.23875V8.875L21.9764 17L29.3026 19.4375L35.0001 17V8.875L21.9764 0.750005Z" fill="#21A366" />
                                                            <path d="M8.14014 8.875H21.9764V17H8.14014V8.875Z" fill="#107C41" />
                                                            <path opacity="0.1" d="M18.0426 7.25H8.14014V27.5625H18.0426C18.4372 27.5605 18.8151 27.4032 19.0945 27.1245C19.3739 26.8458 19.5322 26.4683 19.5351 26.0738V8.73875C19.5322 8.34417 19.3739 7.96665 19.0945 7.68799C18.8151 7.40932 18.4372 7.25196 18.0426 7.25Z" fill="black" />
                                                            <path opacity="0.2" d="M17.2289 8.0625H8.14014V28.375H17.2289C17.6235 28.373 18.0014 28.2157 18.2808 27.937C18.5601 27.6583 18.7184 27.2808 18.7214 26.8862V9.55125C18.7184 9.15667 18.5601 8.77915 18.2808 8.50049C18.0014 8.22182 17.6235 8.06446 17.2289 8.0625Z" fill="black" />
                                                            <path opacity="0.2" d="M17.2289 8.0625H8.14014V26.75H17.2289C17.6235 26.748 18.0014 26.5907 18.2808 26.312C18.5601 26.0333 18.7184 25.6558 18.7214 25.2612V9.55125C18.7184 9.15667 18.5601 8.77915 18.2808 8.50049C18.0014 8.22182 17.6235 8.06446 17.2289 8.0625Z" fill="black" />
                                                            <path opacity="0.2" d="M16.4151 8.0625H8.14014V26.75H16.4151C16.8097 26.748 17.1876 26.5907 17.467 26.312C17.7464 26.0333 17.9047 25.6558 17.9076 25.2612V9.55125C17.9047 9.15667 17.7464 8.77915 17.467 8.50049C17.1876 8.22182 16.8097 8.06446 16.4151 8.0625Z" fill="black" />
                                                            <path d="M1.4925 8.06251H16.415C16.8103 8.06218 17.1895 8.2188 17.4694 8.49796C17.7493 8.77712 17.9068 9.15597 17.9075 9.55126V24.4488C17.9068 24.844 17.7493 25.2229 17.4694 25.5021C17.1895 25.7812 16.8103 25.9378 16.415 25.9375H1.4925C1.29663 25.9382 1.10257 25.9001 0.921434 25.8256C0.740303 25.7511 0.575676 25.6415 0.437002 25.5032C0.298329 25.3648 0.188339 25.2005 0.113347 25.0195C0.0383538 24.8386 -0.000165169 24.6446 5.32345e-07 24.4488V9.55126C-0.000165169 9.35539 0.0383538 9.16142 0.113347 8.98047C0.188339 8.79953 0.298329 8.63518 0.437002 8.49686C0.575676 8.35853 0.740303 8.24895 0.921434 8.17442C1.10257 8.09988 1.29663 8.06185 1.4925 8.06251Z" fill="url(#paint0_linear_204_554)" />
                                                            <path d="M4.625 21.8412L7.76375 16.9862L4.88875 12.1587H7.1975L8.76625 15.2499C8.91125 15.5424 9.01625 15.7599 9.06375 15.9049H9.085C9.1875 15.6708 9.29583 15.4433 9.41 15.2224L11.0875 12.1637H13.2125L10.2638 16.9637L13.2875 21.8449H11.0263L9.21375 18.4562C9.12983 18.3104 9.05833 18.1577 9 17.9999H8.97C8.91702 18.1537 8.84656 18.301 8.76 18.4387L6.89375 21.8412H4.625Z" fill="white" />
                                                            <path d="M33.5073 0.750008H21.9761V8.87501H34.9998V2.23876C35 2.04289 34.9615 1.84892 34.8865 1.66798C34.8115 1.48703 34.7015 1.32268 34.5628 1.18436C34.4241 1.04603 34.2595 0.936455 34.0784 0.861918C33.8973 0.787381 33.7032 0.74935 33.5073 0.750008Z" fill="#33C481" />
                                                            <path d="M21.9761 17H34.9998V25.125H21.9761V17Z" fill="#107C41" />
                                                            <defs>
                                                                <linearGradient id="paint0_linear_204_554" x1="3.1175" y1="6.89251" x2="14.79" y2="27.1075" gradientUnits="userSpaceOnUse">
                                                                    <stop stop-color="#18884F" />
                                                                    <stop offset="0.5" stop-color="#117E43" />
                                                                    <stop offset="1" stop-color="#0B6631" />
                                                                </linearGradient>
                                                            </defs>
                                                        </svg></span>
                                                        <span>
                                                            <p className="filename-taskdetails marginbottom-0">File Name</p>
                                                            <Link to={taskdetails?.uploaded_file} className="underline">View</Link>
                                                        </span>
                                                    </div>

                                                </td>

                                            </tr>





                                        </table>
                                    </div>
                                </div>

                            </div>



                        </div>
                    </div>
                </div>

                <div className="info-box-div-bg margin-top-20">
                    <div className="filters-wrapper">
                        <h2 className="personal-detail-1 font-weight500 font-size-text task-details-heading">
                            Task
                        </h2>
                        <div className="action-buttons">
                            {/* <button className='common-button'>

                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 13H6C5.71667 13 5.47934 12.904 5.288 12.712C5.09667 12.52 5.00067 12.2827 5 12C4.99934 11.7173 5.09534 11.48 5.288 11.288C5.48067 11.096 5.718 11 6 11H11V6C11 5.71667 11.096 5.47934 11.288 5.288C11.48 5.09667 11.7173 5.00067 12 5C12.2827 4.99934 12.5203 5.09534 12.713 5.288C12.9057 5.48067 13.0013 5.718 13 6V11H18C18.2833 11 18.521 11.096 18.713 11.288C18.905 11.48 19.0007 11.7173 19 12C18.9993 12.2827 18.9033 12.5203 18.712 12.713C18.5207 12.9057 18.2833 13.0013 18 13H13V18C13 18.2833 12.904 18.521 12.712 18.713C12.52 18.905 12.2827 19.0007 12 19C11.7173 18.9993 11.48 18.9033 11.288 18.712C11.096 18.5207 11 18.2833 11 18V13Z" fill="white" />
                                </svg> {" "} 
                                
                            </button> */}
                            <AddTask />

                        </div>

                    </div>
                    <div class="table-container">

                        <table className="project-table border-table-top">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className=" table-heading-text">Sr no.</th>
                                    <th className=" table-heading-text">Task Stage</th>
                                    <th className=" table-heading-text">Milestone Name</th>

                                    <th className=" table-heading-text">Assigned Designer</th>

                                    <th className=" table-heading-text">Assigned Draftman</th>
                                    <th className=" table-heading-text">Submission Date <span ref={menuRefrecieve}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 9L12 15L6 9" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" onClick={toggleMenurecieve} />
                                    </svg></span></th>
                                    <th className=" table-heading-text ">Documentations</th>
                                    <th className=" table-heading-text">Status <span ref={menuRefrecieve}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 9L12 15L6 9" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" onClick={toggleMenurecieve} />
                                    </svg></span></th>




                                    <th className="  table-heading-text">Actions</th>


                                </tr>
                            </thead>
                            {buffer ? <div className="spinner-small"></div> :

                                <tbody>
                                    {dummyData

                                        .map((i, index) => (
                                            <React.Fragment key={index}>

                                                <tr className="custom-table-head-td" >
                                                    <td className="table-body">{index < 9 ? `0${index + 1}` : index + 1}</td>
                                                    <td className="table-body">
                                                        <span className="width-progress-name">Gad</span>

                                                        <div className="project-name-bar-container">

                                                            <div className="progress-wrapper">
                                                                <div className="progress-per gad-individual" style={{ width: "100%" }}></div>
                                                            </div>
                                                            <span className="percentage-label">100%</span>
                                                        </div>
                                                    </td>
                                                    <td className="table-body project-name underline">{i.project_code}</td>
                                                    <td className="table-body">{i.client_name}</td>
                                                    <td className="table-body">{i.location}</td>
                                                    <td className="table-body">{i.length}</td>
                                                    <td className="table-body">{i.project_mode}</td>
                                                    <td className="table-body">{i.concern_person}</td>





                                                    <td className="table-body">
                                                        <div className="action-menu-container" ref={menuRef}>
                                                            <button className="action-menu-button" style={{ backgroundColor: (menuopen && index + 1 === menuIndex) ? '#2576BC' : 'transparent' }} onClick={() => toggleMenu(index + 1)}>
                                                                {menuopen && index + 1 === menuIndex ? <svg width="48" height="48" viewBox="0 0 48 48" fill="#2576BC" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="14" cy="24" r="3" fill="#fff" />
                                                                    <circle cx="24" cy="24" r="3" fill="#fff" />
                                                                    <circle cx="34" cy="24" r="3" fill="#fff" />
                                                                </svg> : <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="14" cy="24" r="3" fill="#1E1E1E" />
                                                                    <circle cx="24" cy="24" r="3" fill="#1E1E1E" />
                                                                    <circle cx="34" cy="24" r="3" fill="#1E1E1E" />
                                                                </svg>}


                                                            </button>

                                                            {menuopen && index + 1 === menuIndex && (
                                                                <div className="action-menu-dropdown">
                                                                    <UpdateTask />
                                                                    <span className="action-menu-dropdown-button">
                                                                        {/* <Link onClick={(e) => {
                                                                            e.preventDefault()
                                                                            // getProjectdetails(i.pr_code)
                                                                        }} >
                                                                            View
                                                                        </Link> */}
                                                                        <p style={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>Completed</p>
                                                                    </span>
                                                                    <span className="action-menu-dropdown-button delete-button">

                                                                        Remove

                                                                    </span>

                                                                </div>

                                                            )}
                                                        </div>
                                                    </td>


                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                                // <tbody>
                                //     {renderActivityRows(taskdetails, "0")}
                                // </tbody>

                            }
                        </table>

                    </div>
                </div>
                {/* Tabs and Content */}
                {/* {
                    <div className="filter-outer-box" style={{
                        padding: "0px 30px"
                    }}>
                        <div
                            className="toggle-button-area"
                            style={{
                                padding: "0px 0px 0px 0px",
                                width: "100%",
                            }}
                        >
                            <div className="left-expense-bloc-tab wfm-margin">
                                <div>
                                    <button
                                        className={
                                            toggleState === 1
                                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  dashboardcomponents-tabs-color"
                                        }
                                        onClick={() => settoggleState(1)}
                                    >
                                        Department 1
                                    </button>

                                    <button
                                        className={
                                            toggleState === 2
                                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  dashboardcomponents-tabs-color"
                                        }
                                        onClick={() => settoggleState(2)}
                                    >
                                        Department 2
                                    </button>

                                    <button
                                        className={
                                            toggleState === 3
                                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  dashboardcomponents-tabs-color"
                                        }
                                        onClick={() => settoggleState(3)}
                                    >
                                        Department 3
                                    </button>

                                    <button
                                        className={
                                            toggleState === 4
                                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  dashboardcomponents-tabs-color"
                                        }
                                        onClick={() => settoggleState(4)}
                                    >
                                        Department 4
                                    </button>

                                    <button
                                        className={
                                            toggleState === 5
                                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  dashboardcomponents-tabs-color "
                                        }
                                        onClick={() => settoggleState(5)}
                                    >
                                        Department 5
                                    </button>
                                </div>

                            </div>
                            <div className="right-expense-bloc-tab">
                                <div>
                                    <AddDepartmentDetails
                                        id={project.pr_code}
                                        modalData={project}
                                        allEmployeeData={allEmployeeData}
                                        getProjectDetails={getProjectDetails}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                } */}


            </div>
        </>
    );
};

export default AllTaskdetails;
